import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { filter, permissions as permissionDeco } from 'helpers/decorators'
import { Input, Select } from 'components/fields'
import { Module, Row, Col, FilterActions } from 'components/misc'
import { messages as messagesApi } from 'redux/modules/api'
import { apiCodeLists } from 'helpers/decorators/api'
import { compose } from 'recompose'
import { injectIntl } from 'react-intl'

const enhance = compose(
    injectIntl,
    apiCodeLists(['awardLevelTypes', 'personStates', 'awardStates', 'messageTypes', 'messageStates']),
    permissionDeco(),
    connect(
        ({ api, auth }) => ({
          query: api.messages.filter,
          count: api.messages.count,
          activeOrganization: auth.organization
        }),
        { setFilter: messagesApi.setFilter }
    ),
    filter({
      form: 'messages-filter',
      persist: true,
      defaultFilter: {
        // eslint-disable-next-line camelcase
        person_personState_value: 'ACTIVE'
      }
    })
)

class MessagesFilter extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    awardStates: PropTypes.object.isRequired
  }
  render() {
    const { codeLists } = this.props

    return (
      <Module verticallyNarrow primary>
        <Row alignItems="center" gutters inner>
          <Col flex="0 1 200px">
            <Input
              label="Search"
              name="id||participantPerson_name||awardLeader_person_name||message||groupHash||participantPerson_email@ic"
              intlKey="label.search"
              clearable
            />
          </Col>
          <Col flex="0 1 120px">
              <Select
                  label="Type"
                  intlKey="label.message_type"
                  options={codeLists.messageTypes.list}
                  name="isPraise"
              />
          </Col>
          <Col flex="0 1 120px">
            <Select
                label="Message status"
                intlKey="label.message_status"
                options={codeLists.messageStates.list}
                name="isRead"
            />
          </Col>
          <Col flex="1 1 auto" alignSelf="flex-end" right>
            <FilterActions {...this.props} />
          </Col>
        </Row>
      </Module>
    )
  }
}


export default enhance(MessagesFilter)
